import * as React from 'react';

import { CoreProps } from 'common/types';
import { Input, Select } from 'common/components';
import { RelationOption } from 'common/components/RelationSelect';
import { useUnitsList } from 'modules/units/queries';
import {
  CoreFormLayout,
  FieldsGrid,
  GridItem,
  Section,
  SectionsWrapper,
} from 'templates/core';
import { TitleInput } from 'templates/details';

import { fields, NutritionalValuesFields, validationSchema } from '../consts';
import { useSave } from '../hooks';

const NutritionalValuesCore = ({
  pk,
  defaultValues,
  children,
  layout = 'overview',
}: CoreProps<NutritionalValuesFields>) => {
  const unitList = useUnitsList();
  const { save, isSaving, error, created } = useSave(pk);

  if (!pk) {
    layout = 'creation';
  }

  const unitOptions: RelationOption[] =
    unitList.data?.values.map((unit) => ({
      label: unit.name_singular,
      value: unit.pk,
    })) || [];

  return (
    <>
      <CoreFormLayout
        onSubmit={save}
        defaultValues={defaultValues}
        validationSchema={validationSchema}
        isSubmitting={isSaving}
        error={error}
      >
        <Section>
          {layout === 'overview' && <TitleInput name={fields.name.name} />}
          {layout === 'creation' && (
            <Input name={fields.name.name} label={fields.name.label} />
          )}
        </Section>
        <Section>
          <FieldsGrid>
            <GridItem>
              <Select
                name={fields.unit.name}
                label={fields.unit.label}
                options={unitOptions}
              />
            </GridItem>
          </FieldsGrid>
        </Section>
      </CoreFormLayout>
      <SectionsWrapper pk={created}>{children}</SectionsWrapper>
    </>
  );
};

export default NutritionalValuesCore;
